import { Link } from "react-router-dom";
import { formatINR } from "@/lib/api";

export default function ProductCard({ p, tall = false }) {
  const img = p.images?.[0];
  const discount = p.compare_at ? Math.round((1 - p.starts_at / p.compare_at) * 100) : 0;
  return (
    <Link to={`/product/${p.slug}`} className="group block" data-testid={`product-card-${p.slug}`}>
      <div className={`img-cinematic ${tall ? "aspect-[3/4]" : "aspect-[4/5]"} relative`} style={{ background: "#141414" }}>
        {img && <img src={img} alt={p.name} className="w-full h-full object-cover" loading="lazy" />}
        {p.new_arrival && (
          <div className="absolute top-4 left-4">
            <span className="ribbon-bronze">Direct from Factory</span>
          </div>
        )}
      </div>
      <div className="mt-5 flex justify-between items-start gap-3">
        <div>
          <div className="font-micro text-[#8A8680] mb-1">{p.category?.replace("-", " ")}</div>
          <div className="font-serif text-[#EDE4D3] text-xl leading-tight group-hover:text-[#B8895C] transition-colors duration-700">
            {p.name}
          </div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-micro text-[#8A8680] mb-1">starts at</div>
          <div className="font-serif text-[#EDE4D3] text-lg">{formatINR(p.starts_at)}</div>
          {discount > 0 && <div className="font-micro text-[#B8895C] mt-1">−{discount}%</div>}
        </div>
      </div>
    </Link>
  );
}
